import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.13 18.31h8c2.76 0 5-2.24 5-5s-2.24-5-5-5h-11",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      d: "M6.43 10.81 3.87 8.25l2.56-2.56",
      "stroke-width": "1.5"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }